module.exports = __webpack_public_path__ + "98dd589ca87bd6ed069db1740fcd0704.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/gift.png
// module id = 2847
// module chunks = 0